export const gender = [
    { label: "Female", value: "Female" },
    { label: "Male", value: "Male" },
]